import type { SelectOption } from "@cinnamon/design-system/types";

import { type IDataEnhancement } from "./pipeline";

export type DataEnhancementId = string;

export enum STEP_TYPE_DATA_ENHANCEMENT_OLD {
  FIND_AND_REPLACE = "find-and-replace",
  TRIM_SPACES = "trim-spaces",
  FORMAT_TEXT = "format-text",
}

export enum FORMAT_TEXT_TYPE_DATA_ENHANCEMENT {
  LITERAL = "literal",
  PLACEHOLDER = "placeholder",
}

export interface IFieldInfo {
  id: string;
  display_name: string;
}

export type DataEnhancementValue = string | string[] | SelectOption;

export interface IDataEnhancementOld {
  id: string;
  action?: STEP_TYPE_DATA_ENHANCEMENT_OLD | null;
  input: IFieldInfo[];
  output: IFieldInfo[];
  description: string;
  value: DataEnhancementValue[];

  canExpand?: boolean;
}

export interface ITemplateDataEnhancement {
  type: FORMAT_TEXT_TYPE_DATA_ENHANCEMENT;
  value: string;
}
// - old data enhancement
export type FixFormDataEnhancementServer = Partial<Omit<IDataEnhancementOld, "input" | "output">> & {
  template?: ITemplateDataEnhancement[];
  find?: string;
  replace?: string;
  remove_all?: boolean;
  input: string[];
  output: string;
};

export type DataEnhancementServer = Partial<Omit<IDataEnhancement, "input" | "output">> & {
  template?: ITemplateDataEnhancement[];
  find?: string;
  replace?: string;
  remove_all?: boolean;
  input: string[];
  output: string[];
};
